import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'app/auth/service';

@Injectable({
  providedIn: 'root', // ensures DI knows about it
})

export class SessionGuard {
  /**
   *
   * @param {Router} _router
   * @param {AuthenticationService} _authenticationService
   */
  constructor(
    private _router: Router,
    private _authenticationService: AuthenticationService
  ) { }

  // canActivate
  async canActivate() {
    const isLogin = await this._authenticationService.isLoggedIn();
    if (!isLogin) {
      return true;
    }
    this._router.navigate(['/']);
    return false;
  }
}
